//* main reikmenys
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { RequireAuth, useAuthUser, useIsAuthenticated } from 'react-auth-kit'
//* layoutas
import MainLayout from '../layouts/Main'
import DashLayout from '../layouts/Dash'
//! Puslapiai
//* autentifikacija
import Login from './pages/Login'
//* prietaisų skydelis
import Dashboard from './pages/Dashboard'
//* asmenys
import People from './pages/people/People'
import Person from './pages/people/Person'
//* vartotojai
import Users from './pages/users/Users'
import User from './pages/users/User'
//* globėjai
import Guardians from './pages/guardians/Guardians'
import Guardian from './pages/guardians/Guardian'
//* globėjai
import Subjects from './pages/subjects/Subjects'
import Subject from './pages/subjects/Subject'
//* mokytojai
import Teachers from './pages/teachers/Teachers'
import Teacher from './pages/teachers/Teacher'
//* tvarkaraštis
import Timetable from './pages/timetable/Timetable'
//* moksleiviai
import Students from './pages/students/Students'
import Student from './pages/students/Student'
//* kabinetai
import Classrooms from './pages/classrooms/Classrooms'
//* klasės
import Classes from './pages/classes/Classes'
import Class from './pages/classes/Class'
//* paskyrimai
import StudentAssignment from './pages/StudentAssignment'

//* msc
import school from '../school.svg'

export default function RoutesComponent() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<MainLayout />}>
          <Route exact path='/login' element={<Login />} />      
          <Route exact path='/studentassignment/:slug' element={<StudentAssignment />} />      
          <Route exact index element={<Home />} />
          
          <Route path="*" element={<>404</>} />
        </Route>
        <Route path='/dashboard' element={<DashLayout />}>
          <Route exact index element={
            <RequireAuth loginPath={'/login'}>
              <Dashboard />
            </RequireAuth>
          }/>
          <Route path='people'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <People />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Person />
              </RequireAuth>} />
          </Route>
          <Route path='users'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Users />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <User />
              </RequireAuth>} />
          </Route>
          <Route path='guardians'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Guardians />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Guardian />
              </RequireAuth>} />
          </Route>
          <Route path='subjects'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Subjects />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Subject />
              </RequireAuth>} />
          </Route>
          <Route path='teachers'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Teachers />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Teacher />
              </RequireAuth>} />
          </Route>
          <Route path='timetable'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Timetable />
              </RequireAuth>} />
              {/* <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Teacher />
              </RequireAuth>} /> */}
          </Route>
          <Route path='students'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Students />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Student />
              </RequireAuth>} />
          </Route>
          <Route path='classrooms'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Classrooms />
              </RequireAuth>} />
          </Route>
          <Route path='classes'>
              <Route exact index element={
              <RequireAuth loginPath={'/login'}>
                <Classes />
              </RequireAuth>} />
              <Route exact path=':id' element={
              <RequireAuth loginPath={'/login'}>
                <Class />
              </RequireAuth>} />
          </Route>
        </Route>
      </Routes>
    </Router>
  )
}

function Home() {
  const isAuthenticated = useIsAuthenticated()
  const autha = useAuthUser()

  return(
    <div className='flex justify-center items-center flex-wrap gap-12 h-full'>
      <div>
        <h1>Mokyklos administracinė sistema</h1>
        {isAuthenticated()
            ? <h2 className='text-gray-800'>Sveiki, {autha().user.person.name}</h2>
            : <h2 className='text-gray-800'>Prašome prisijungti</h2>
        }
      </div>
      <img
        className="h-[50%] w-auto"
        src={school}
        alt=""
      />
    </div>
  )
}